import { callAPI } from "../helper/apiUtils";

/**
 * Create an internal Kjuup+ room via the same API as Add Project, then the
 * caller can file the email into the returned building id.
 *
 * Classify's own "create by name" path is external-only on older backends, and
 * internal rooms must have buildingProjectType=1 plus UserBuilding.company set
 * to the Kjuup+ company or they land in the external list.
 */
export async function createInternalEmailRoom(name, companyId) {
  const clean = String(name || "").trim();
  if (!clean) {
    const err = new Error("Project name is required");
    err.code = "NAME_REQUIRED";
    throw err;
  }
  if (!companyId) {
    const err = new Error("A Kjuup+ company is required to create an internal project");
    err.code = "KJUUP_COMPANY_REQUIRED";
    throw err;
  }
  const res = await callAPI("/building/createInternalBuilding", "", "POST", {
    name: clean,
    companyId,
  });
  const data = res?.data || res;
  const building = data && data.data;
  if (!data || data.status === false || !building) {
    const err = new Error((data && data.message) || "Unable to create internal project");
    err.code = "CREATE_FAILED";
    throw err;
  }
  return {
    id: building.id,
    name: building.name || clean,
    themeColor: building.themeColor || null,
  };
}

export async function createExternalEmailRoom(name, companyId) {
  const clean = String(name || "").trim();
  if (!clean) {
    const err = new Error("Project name is required");
    err.code = "NAME_REQUIRED";
    throw err;
  }
  const payload = { name: clean, isHidden: false };
  if (companyId) payload.companyId = companyId;
  const res = await callAPI("/building", "", "POST", payload);
  const data = res?.data || res;
  const building = data && data.data;
  if (!data || data.status === false || !building) {
    const err = new Error((data && data.message) || "Unable to create project");
    err.code = "CREATE_FAILED";
    throw err;
  }
  return {
    id: building.id,
    name: building.name || clean,
    themeColor: building.themeColor || null,
  };
}
